import { useMutation } from '@tanstack/react-query'

import {
  AutoReportDeleteBodyDto,
  AutoReportGetParams,
  AutoReportParams,
  AutoReportSubscriptionDtoResponse,
  ReportParams,
} from '../types.ts'
import { omitRequestParams } from '../utils.ts'

import { apiService } from './root.ts'
import { MessageResponse } from './services.types.ts'

const REPORT_ROOT = '/client-reports/reports'
const AUTO_REPORT_ROOT = '/client-reports'

export const CLIENT_REPORTS_ENDPOINTS = {
  subscribe: `${AUTO_REPORT_ROOT}/auto-reports`,
  unsubscribe: `${AUTO_REPORT_ROOT}/auto-reports/batch-unsubscribe`,
  getSubscriptions: `${AUTO_REPORT_ROOT}/auto-reports/list`,
  sbpPaymentReport: `${REPORT_ROOT}/sbp-payments`,
  // https://confluence.frhc.group/pages/viewpage.action?pageId=503578729
  b2cPaymentReport: `${REPORT_ROOT}/b2c-sbp-payments`,
  acqReport: `${REPORT_ROOT}/acq-payments`,
}

export const useCreateAutoReportMutation = () =>
  useMutation({
    mutationFn: (bodyParams: AutoReportParams) =>
      apiService.post<MessageResponse>(CLIENT_REPORTS_ENDPOINTS.subscribe, { bodyParams }),
  })

export const useDeleteAutoReportMutation = () =>
  useMutation({
    mutationFn: (bodyParams: AutoReportDeleteBodyDto) =>
      apiService.post<MessageResponse>(CLIENT_REPORTS_ENDPOINTS.unsubscribe, { bodyParams }),
  })

export const useRequestB2CReport = () =>
  useMutation({
    mutationFn: (queryParams: Record<string, unknown>) =>
      apiService.get<Blob>(CLIENT_REPORTS_ENDPOINTS.b2cPaymentReport, {
        queryParams: omitRequestParams(queryParams),
        axiosParams: { responseType: 'blob' },
      }),
  })

export const useRequestSbpReport = () =>
  useMutation({
    mutationFn: (queryParams: ReportParams) =>
      apiService.get<Blob>(CLIENT_REPORTS_ENDPOINTS.sbpPaymentReport, {
        queryParams: omitRequestParams(queryParams),
        axiosParams: { responseType: 'blob' },
      }),
  })

export const useRequestAcqReport = () =>
  useMutation({
    mutationFn: (queryParams: ReportParams) =>
      apiService.get<Blob>(CLIENT_REPORTS_ENDPOINTS.acqReport, {
        queryParams: omitRequestParams(queryParams),
        axiosParams: { responseType: 'blob' },
      }),
  })

export const useGetSubscriptionAutoReports = () =>
  useMutation({
    mutationFn: (queryParams: AutoReportGetParams) =>
      apiService.get<AutoReportSubscriptionDtoResponse[]>(CLIENT_REPORTS_ENDPOINTS.getSubscriptions, {
        queryParams: omitRequestParams(queryParams),
      }),
  })
